'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "defaultSelected", "selected", "defaultOpen", "open", "onOpenChange"],
  _excluded2 = ["className", "placeholder", "size", "forcedValue", "onMaskSelection"];
import * as React from 'react';
import { cn } from "../utils";
import { DropdownContext, useDropdownContext } from "./context";
import { PrimitiveDropdown, PrimitiveDropdownClientSearch, PrimitiveDropdownContent, PrimitiveDropdownEmpty, PrimitiveDropdownTrigger, PrimitiveDropdownValueButton } from "./primitive-dropdown/primitive-dropdown";
import { jsx as _jsx } from "react/jsx-runtime";
var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
    _ref$defaultSelected = _ref.defaultSelected,
    defaultSelected = _ref$defaultSelected === void 0 ? [] : _ref$defaultSelected,
    selected = _ref.selected,
    _ref$defaultOpen = _ref.defaultOpen,
    defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
    controlledOpen = _ref.open,
    onControlledOpenChange = _ref.onOpenChange,
    popoverProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(defaultOpen),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    uncontrolledOpen = _React$useState2[0],
    setUncontrolledOpen = _React$useState2[1];
  var initialValues = selected || defaultSelected;
  var _React$useState3 = React.useState(Array.isArray(initialValues) ? initialValues.map(function (item) {
      return item.value;
    }) : [initialValues.value]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    values = _React$useState4[0],
    setValues = _React$useState4[1];
  var _React$useState5 = React.useState(Array.isArray(initialValues) ? initialValues : [initialValues]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    items = _React$useState6[0],
    setItems = _React$useState6[1];
  var selectedItems = React.useMemo(function () {
    if (selected) {
      return Array.isArray(selected) ? selected : [selected];
    }
    var selectedArray = [];
    values.forEach(function (value) {
      var item = items.find(function (item) {
        return item.value === value;
      });
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (item) selectedArray.push(item);
    });
    return selectedArray;
  }, [selected, values, items]);
  var open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
  var setOpen = onControlledOpenChange !== null && onControlledOpenChange !== void 0 ? onControlledOpenChange : setUncontrolledOpen;
  return /*#__PURE__*/_jsx(DropdownContext.Provider, {
    value: {
      open: open,
      values: values,
      items: items,
      selectedItems: selectedItems,
      setOpen: setOpen,
      setValues: setValues,
      setItems: setItems
    },
    children: /*#__PURE__*/_jsx(PrimitiveDropdown, _objectSpread(_objectSpread({
      open: open,
      onOpenChange: setOpen
    }, popoverProps), {}, {
      children: children
    }))
  });
};
var DropdownTrigger = PrimitiveDropdownTrigger;
var DropdownValue = function DropdownValue(_ref2) {
  var className = _ref2.className,
    placeholder = _ref2.placeholder,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'small' : _ref2$size,
    forcedValue = _ref2.forcedValue,
    onMaskSelection = _ref2.onMaskSelection,
    popoverTriggerProps = _objectWithoutProperties(_ref2, _excluded2);
  var _useDropdownContext = useDropdownContext(),
    selectedItems = _useDropdownContext.selectedItems,
    open = _useDropdownContext.open;
  var selectedValues = selectedItems.map(function (item) {
    return item.label;
  }).join(', ');
  var translatedSelectedValues = (onMaskSelection === null || onMaskSelection === void 0 ? void 0 : onMaskSelection(selectedValues)) || selectedValues;
  return /*#__PURE__*/_jsx(PrimitiveDropdownTrigger, _objectSpread(_objectSpread({
    asChild: true
  }, popoverTriggerProps), {}, {
    children: /*#__PURE__*/_jsx(PrimitiveDropdownValueButton, {
      className: className,
      size: size,
      open: open,
      placeholder: placeholder,
      value: forcedValue !== null && forcedValue !== void 0 ? forcedValue : translatedSelectedValues
    })
  }));
};
var DropdownContent = PrimitiveDropdownContent;
var DropdownSearchInput = PrimitiveDropdownClientSearch;
var DropdownClearButton = function DropdownClearButton(_ref3) {
  var label = _ref3.label,
    className = _ref3.className,
    _ref3$unstyled = _ref3.unstyled,
    unstyled = _ref3$unstyled === void 0 ? false : _ref3$unstyled;
  var _useDropdownContext2 = useDropdownContext(),
    setValues = _useDropdownContext2.setValues;
  var handleClearAll = function handleClearAll() {
    return setValues([]);
  };
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    onClick: handleClearAll,
    className: cn(!unstyled && 'tw-w-full tw-text-left tw-py-1.2 tw-px-2.4 tw-font-caption tw-text-primary-light-500 dark:tw-text-secondary-light-500 hover:tw-text-primary-light-400 hover:dark:tw-text-secondary-light-400 hover:tw-bg-neutral-light-300 dark:hover:tw-bg-neutral-dark-600', className),
    id: "clear-all",
    children: label
  });
};
var DropdownEmpty = PrimitiveDropdownEmpty;
export { Dropdown, DropdownClearButton, DropdownContent, DropdownEmpty, DropdownSearchInput, DropdownTrigger, DropdownValue };